var clearButtonStyle = 'styles__l6qbuv18 styles__l6qbuvb styles__l6qbuva';
var componentStyle = {
  'boxOutline.large': 'styles__l6qbuvd',
  'boxOutline.medium': 'styles__l6qbuvd',
  'boxOutline.small': 'styles_boxOutline.small__l6qbuvg styles__l6qbuvd',
  'boxOutline.xsmall': 'styles_boxOutline.xsmall__l6qbuvh styles__l6qbuvd',
  'boxFill.large': 'styles__l6qbuvd',
  'boxFill.medium': 'styles__l6qbuvd',
  'boxFill.small': 'styles_boxFill.small__l6qbuvk styles__l6qbuvd',
  'boxFill.xsmall': 'styles_boxFill.xsmall__l6qbuvl styles__l6qbuvd',
  'line.large': 'styles_line.large__l6qbuvm styles__l6qbuvd',
  'line.medium': 'styles_line.medium__l6qbuvn styles__l6qbuvd'
};
var hintStyle = 'styles__l6qbuvo';
var inputStyle = 'styles__l6qbuv17';
var prefixIconStyle = 'styles__l6qbuv1a styles__l6qbuv19 styles__l6qbuvb styles__l6qbuva';
var prefixStyle = 'styles__l6qbuv19 styles__l6qbuvb styles__l6qbuva';
var suffixIconStyle = 'styles__l6qbuv1d styles__l6qbuv1b styles__l6qbuvb styles__l6qbuva';
var suffixTextStyle = 'styles__l6qbuv1c styles__l6qbuv1b styles__l6qbuvb styles__l6qbuva';
var textFieldVariants = {
  'boxOutline.large': 'styles_boxOutline.large__l6qbuvw styles_large__l6qbuvp styles__l6qbuvc styles__l6qbuva styles__l6qbuvt',
  'boxOutline.medium': 'styles_boxOutline.medium__l6qbuvx styles_medium__l6qbuvq styles__l6qbuvc styles__l6qbuva styles__l6qbuvt',
  'boxOutline.small': 'styles_boxOutline.small__l6qbuvy styles_small__l6qbuvr styles__l6qbuvc styles__l6qbuva styles__l6qbuvt',
  'boxOutline.xsmall': 'styles_boxOutline.xsmall__l6qbuvz styles_xsmall__l6qbuvs styles__l6qbuvc styles__l6qbuva styles__l6qbuvt',
  'boxFill.large': 'styles_large__l6qbuvp styles__l6qbuvc styles__l6qbuva styles__l6qbuvu styles__l6qbuvt',
  'boxFill.medium': 'styles_medium__l6qbuvq styles__l6qbuvc styles__l6qbuva styles__l6qbuvu styles__l6qbuvt',
  'boxFill.small': 'styles_small__l6qbuvr styles__l6qbuvc styles__l6qbuva styles__l6qbuvu styles__l6qbuvt',
  'boxFill.xsmall': 'styles_xsmall__l6qbuvs styles__l6qbuvc styles__l6qbuva styles__l6qbuvu styles__l6qbuvt',
  'line.large': 'styles_line.large__l6qbuv14 styles_large__l6qbuvp styles__l6qbuvc styles__l6qbuva styles__l6qbuvv',
  'line.medium': 'styles_line.medium__l6qbuv15 styles_medium__l6qbuvq styles__l6qbuvc styles__l6qbuva styles__l6qbuvv'
};
var titleStyle = 'styles__l6qbuv16';
var vars = {
  inputHeight: 'var(--l6qbuv0)',
  inputPadding: 'var(--l6qbuv1)',
  inputFontSize: 'var(--l6qbuv2)',
  backgroundColor: 'var(--l6qbuv3)',
  titleColor: 'var(--l6qbuv4)',
  stateColor: 'var(--l6qbuv5)',
  iconOffset: 'var(--l6qbuv6)',
  hintOffset: 'var(--l6qbuv7)',
  titleOffset: 'var(--l6qbuv8)',
  optionalHintColor: 'var(--l6qbuv9)'
};
export { clearButtonStyle, componentStyle, hintStyle, inputStyle, prefixIconStyle, prefixStyle, suffixIconStyle, suffixTextStyle, textFieldVariants, titleStyle, vars };
